<template>
  <el-dialog v-model="isShowList" width="70%" :destroy-on-close="true">
    <template #header> 商户名称 : {{ merchantInfo.merchant_name }} </template>
    <div class="table-head">
      <span class="table-title">商户门店列表</span>
      <span class="table-btn">
        <el-button @click="addStore" type="primary">
          <el-icon style="color: #fff">
            <Plus />
          </el-icon>
          <span style="margin-left: 15px">添加门店</span>
        </el-button>

        <el-button @click="openDelOrderAuthDialog" type="primary">
          <el-icon style="color: #fff">
            <Setting />
          </el-icon>
          <span style="margin-left: 15px">商户授权</span>
        </el-button>
      </span>
    </div>
    <div class="table-main">
      <el-table :data="storesData" style="width: 100%" v-loading="storesloading">
        <el-table-column label="序号" width="80" type="index" align="center">
          <template #default="scope">
            {{ (storePage.currentPage - 1) * storePage.perPage + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="no" label="门店账号" width="100px" />
        <el-table-column prop="name" label="门店名称" />
        <el-table-column prop="address" label="门店地址" />
        <el-table-column prop="contact_name" label="联系人" width="100px" />
        <el-table-column prop="phone" label="联系电话" width="180px" />
        <el-table-column prop="devices_count" label="已绑定设备数量" width="160px" />
        <el-table-column label="操作" width="220px" align="center">
          <template #default="scope">
            <el-link style="margin-left:15px" type="primary" @click="handleEdit(scope.row)">编辑</el-link>
            <el-link style="margin-left:15px" type="primary"
              @click="openStoreDelOrderAuthDialog(scope.row)">门店授权</el-link>
            <!-- <el-link style="margin-left:15px" type="primary" @click="handlePlugin(scope.row)">收银插件开通</el-link> -->
          </template>
        </el-table-column>
        <template #empty>
          <el-empty description="空数据" :image-size="200" />
        </template>
      </el-table>
      <div class="pagination">
        <el-pagination background layout="total, prev, pager, next" :total="storePage.total"
          @current-change="storesPageChange" :page-size="storePage.perPage" :current-page="storePage.currentPage" />
      </div>
    </div>

    <!-- edit/add store dialog -->
    <el-dialog v-model="isShowEditStore" width="40%" :destroy-on-close="true">
      <template #header>
        {{ isEditMode ? '编辑门店' : '添加门店' }}
      </template>
      <el-form ref="editFormRef" :model="editData" :rules="rules" label-width="150px">
        <el-row>
          <el-col :span="20">
            <el-form-item label="门店名称" prop="name">
              <el-input v-model="editData.name" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="门店地址" prop="address">
              <el-input v-model="editData.address" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="联系人" prop="contact_name">
              <el-input v-model="editData.contact_name" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="联系电话" prop="phone">
              <el-input v-model="editData.phone" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="门店密码" prop="password">
              <el-input v-model="editData.password" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="状态" prop="status">
              <el-radio-group v-model="editData.status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <el-button @click="isShowEditStore = false">取消</el-button>
        <el-button type="primary" @click="handleEditSubmit">{{ isEditMode ? '确定' : '添加' }}</el-button>
      </template>
    </el-dialog>
    <!-- edit/add store dialog end -->
    <!-- 商户授权弹窗 -->
    <el-dialog v-model="isShowDelOrderAuth" width="40%" :destroy-on-close="true">
      <template #header>
        商户授权
      </template>
      <el-form ref="delOrderAuthFormRef" :model="delOrderAuthForm" :rules="delOrderAuthRules" label-width="150px">
        <el-row>
          <el-col :span="20">
            <el-form-item label="授权删除订单" prop="can_delete_order">
              <el-radio-group v-model="delOrderAuthForm.can_delete_order">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="授权商户显示手续费" prop="show_handling_fee">
              <el-radio-group v-model="delOrderAuthForm.show_handling_fee">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <el-button @click="isShowDelOrderAuth = false">取消</el-button>
        <el-button type="primary" @click="handleDelOrderAuthSubmit">确定</el-button>
      </template>
    </el-dialog>
    <!-- 商户授权弹窗 end -->

    <!-- 门店授权弹窗 -->
    <el-dialog v-model="isShowStoreDelOrderAuth" width="40%" :destroy-on-close="true">
      <template #header>
        门店授权（{{ currentStore.name || '' }}）
      </template>
      <el-form ref="storeDelOrderAuthFormRef" :model="storeDelOrderAuthForm" :rules="storeDelOrderAuthRules"
        label-width="150px">
        <el-row>
          <el-col :span="20">
            <el-form-item label="授权删除订单" prop="can_delete_order">
              <el-radio-group v-model="storeDelOrderAuthForm.can_delete_order">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="20">
            <el-form-item label="授权商户显示手续费" prop="show_handling_fee">
              <el-radio-group v-model="storeDelOrderAuthForm.show_handling_fee">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <el-button @click="isShowStoreDelOrderAuth = false">取消</el-button>
        <el-button type="primary" @click="handleStoreDelOrderAuthSubmit">确定</el-button>
      </template>
    </el-dialog>
    <!-- 门店授权弹窗 end -->
  </el-dialog>
</template>

<script setup>
import { ref, defineExpose, getCurrentInstance, reactive, defineEmits } from 'vue'
import { nextTick } from 'process';
import { ElMessage } from 'element-plus'
import { Plus, Setting } from "@element-plus/icons-vue";
import { phone } from '@/tools/validatorFunc'
// import { useRouter } from "vue-router"

// const route = useRouter()
const { proxy } = getCurrentInstance() // 当前实例
const merchantInfo = ref('')
const isShowList = ref(false)
const show_handling_fee = ref(1) // 商户级显示手续费状态缓存
// LIST
const storesloading = ref(true)
let storesData = ref()
let storePage = reactive({
  currentPage: 0,
  perPage: 0,
  total: 0,
  totalPages: 0
})

const storesPageChange = (page) => {
  queryStoresList({ page: page, merchant_id: merchantInfo.value.id })
}

const handleEdit = (row) => {
  isEditMode.value = true
  nextTick(() => {
    isShowEditStore.value = true
    editData.value = { ...row }
  })
}

// const handlePlugin = (row) => {
//   route.push({
//     path: '/users/plugin',
//     query: {
//       id: row.id,
//       name: row.name
//     }
//   })
// }
// LIST END

// EDIT/ADD
const isShowEditStore = ref(false)
const isEditMode = ref(false)
const editData = ref({ name: '', address: '', contact_name: '', phone: '', status: 1, password: '' })

const rules = reactive({
  name: [
    { required: true, message: '必填项' }
  ],
  address: [
    { required: true, message: '必填项' }
  ],
  contact_name: [
    { required: true, message: '必填项' }
  ],
  phone: [
    { required: true, message: '必填项' },
    { validator: phone, trigger: 'change' }
  ],
  status: [
    { required: true, message: '必填项' }
  ]
})

const handleEditSubmit = () => {
  proxy.$refs.editFormRef.validate((validate) => {
    if (validate) {
      const apiCall = isEditMode.value
        ? proxy.$api.merchants.editStores(editData.value.id, editData.value)
        : proxy.$api.merchants.addStore(editData.value)
      apiCall.then(res => {
        if (res.status == 200) {
          ElMessage({
            message: isEditMode.value ? '数据修改成功' : '门店添加成功',
            type: 'success',
          })
          isShowEditStore.value = false
          queryStoresList({ merchant_id: merchantInfo.value.id })
        } else {
          ElMessage.error('操作失败，请稍后重试')
          isShowEditStore.value = false
        }
      })
    }
  })
}

const addStore = () => {
  isEditMode.value = false
  editData.value = { name: '', address: '', contact_name: '', phone: '', status: 1, password: '', merchant_id: merchantInfo.value.id, agent_id: merchantInfo.value.agent_id }
  isShowEditStore.value = true
}

const queryStoresList = (data) => {
  storesloading.value = true
  proxy.$api.merchants.queryStores(data).then(res => {
    if (res.status == 200) {
      storesData.value = res.data.data
      storePage.currentPage = res.data.pagination.currentPage
      storePage.perPage = res.data.pagination.perPage
      storePage.total = res.data.pagination.total
      storePage.totalPages = res.data.pagination.totalPages
      storesloading.value = false
    } else {
      ElMessage.error('加载失败')
    }
  })
}

// 商户授权相关
const isShowDelOrderAuth = ref(false) // 删除订单授权弹窗开关
const canDeleteOrder = ref(0)
const delOrderAuthForm = ref({
  can_delete_order: 0, // 初始化，默认未授权删除订单
  show_handling_fee: 1 // 初始化显示手续费状态
})

const openDelOrderAuthDialog = () => {
  isShowDelOrderAuth.value = true
  // 回显当前商户的授权状态
  delOrderAuthForm.value.can_delete_order = canDeleteOrder.value
  delOrderAuthForm.value.show_handling_fee = show_handling_fee.value // 回显显示手续费状态
}
// 商户授权表单校验规则
const delOrderAuthRules = reactive({
  can_delete_order: [
    { required: true, message: '请选择是否授权删除订单', trigger: 'change' }
  ],
  show_handling_fee: [ // 新增：显示手续费必填校验
    { required: true, message: '请选择是否授权显示手续费', trigger: 'change' }
  ]
})
// 定义要派发的事件
const emit = defineEmits(['refresh'])
// 提交商户授权的方法
const handleDelOrderAuthSubmit = () => {
  proxy.$refs.delOrderAuthFormRef.validate((validate) => {
    if (validate) {
      // 先提交删除订单授权
      proxy.$api.merchants.deleteMerchantOrder({
        merchant_id: merchantInfo.value.id,
        can_delete_order: delOrderAuthForm.value.can_delete_order
      }).then(res => {
        if (res.status == 200) {
          // 再调用独立的商户显示手续费接口
          proxy.$api.merchants.showMerchantHandlingFee({
            merchant_id: merchantInfo.value.id,
            show_handling_fee: delOrderAuthForm.value.show_handling_fee
          }).then(feeRes => {
            if (feeRes.status == 200) {
              ElMessage.success('商户授权状态修改成功')
              isShowDelOrderAuth.value = false
              // 更新本地缓存的授权状态
              canDeleteOrder.value = delOrderAuthForm.value.can_delete_order
              show_handling_fee.value = delOrderAuthForm.value.show_handling_fee
              emit('refresh')
            } else {
              ElMessage.error('显示手续费授权修改失败，请稍后重试')
            }
          })
        } else {
          ElMessage.error('删除订单授权修改失败，请稍后重试')
        }
      })
    }
  })
}

// 门店级授权相关
const isShowStoreDelOrderAuth = ref(false) // 门店授权弹窗开关
const currentStore = ref({}) // 选中的门店数据
const storeDelOrderAuthForm = ref({
  can_delete_order: 0, // 门店授权删除订单状态
  show_handling_fee: 1 // 门店显示手续费状态
})
// 门店授权表单校验规则
const storeDelOrderAuthRules = reactive({
  can_delete_order: [
    { required: true, message: '请选择是否授权删除订单', trigger: 'change' }
  ],
  show_handling_fee: [ // 新增：门店显示手续费必填校验
    { required: true, message: '请选择是否授权显示手续费', trigger: 'change' }
  ]
})

// 打开门店授权弹窗（接收门店行数据）
const openStoreDelOrderAuthDialog = (row) => {
  currentStore.value = row // 保存当前门店数据
  isShowStoreDelOrderAuth.value = true
  // 回显门店当前授权状态
  storeDelOrderAuthForm.value.can_delete_order = row.can_delete_order
  storeDelOrderAuthForm.value.show_handling_fee = row.show_handling_fee
}

// 提交门店授权的方法
const handleStoreDelOrderAuthSubmit = () => {
  proxy.$refs.storeDelOrderAuthFormRef.validate((validate) => {
    if (validate) {
      // 先提交门店删除订单授权
      proxy.$api.merchants.deleteStoreOrder({
        store_id: currentStore.value.id, // 传门店ID
        can_delete_order: storeDelOrderAuthForm.value.can_delete_order
      }).then(res => {
        if (res.status == 200) {
          // 再调用独立的门店显示手续费接口
          proxy.$api.merchants.showStoreHandlingFee({
            store_id: currentStore.value.id,
            show_handling_fee: storeDelOrderAuthForm.value.show_handling_fee
          }).then(feeRes => {
            if (feeRes.status == 200) {
              ElMessage.success('门店授权状态修改成功')
              isShowStoreDelOrderAuth.value = false
              // 刷新门店列表
              queryStoresList({ merchant_id: merchantInfo.value.id })
              emit('refresh')
            } else {
              ElMessage.error('门店显示手续费授权修改失败，请稍后重试')
            }
          })
        } else {
          ElMessage.error('门店删除订单授权修改失败，请稍后重试')
        }
      })
    }
  })
}

const open = (item) => {
  isShowList.value = true
  merchantInfo.value = item
  canDeleteOrder.value = item.can_delete_order
  show_handling_fee.value = item.show_handling_fee

  nextTick(() => {
    queryStoresList({ merchant_id: item.id })
  })
}

defineExpose({ open })
</script>

<style lang="less" scoped>
.table-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
}

.table-main {
  margin: 1.25rem 0;

  .pagination {
    margin: 1.25rem 0;
    display: flex;
    justify-content: flex-end;
  }
}
</style>